import script from "./BookCourt.vue?vue&type=script&setup=true&lang=js"
export * from "./BookCourt.vue?vue&type=script&setup=true&lang=js"

import "./BookCourt.vue?vue&type=style&index=0&id=2b4857e6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b4857e6"]])

export default __exports__